
import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { selectTransactions } from '../Redux/slices/transactionState'
import { getDateString, getTimeString } from '../Utils/GetTimeStamp'
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
import NavigateBeforeRoundedIcon from '@mui/icons-material/NavigateBeforeRounded';
import FilterBar from './FilterBar'
export default function TransactionTable({ selectedRecord, selectHandler }) {

    const navigate = useNavigate()
    const transactions = useSelector(selectTransactions)
    const summary = {
        totalQuantity: 0,
        totalBill: 0,
        totalPaid: 0,
    }
    const generateBill = () => {
        navigate('/generatebill', { state: { transactions } })
    }
    
    return (
        <>
            <FilterBar />
            <div id='transactionTable' className="flex flex-col my-6 ">
                <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                        <div className="overflow-x-auto">
                            <table className="w-full min-w-full table-auto border-spacing-2 border-collapse border-b border-x-2  text-center shadow-md">
                                <thead className='bg-sky-500 text-white'>
                                    <tr >
                                        <th className='py-3 px-3 whitespace-nowrap rounded-tl-md'>Date</th>
                                        <th className='py-3 px-3 whitespace-nowrap rounded-tr-md'>Time</th>
                                        <th className='py-3 px-3 whitespace-nowrap'>Party Name</th>
                                        <th className='py-3 px-3 whitespace-nowrap'>Supplier Name</th>
                                        <th className='py-3 px-3 whitespace-nowrap'>Material</th>
                                        <th className='py-3 px-3 whitespace-nowrap'>Qty</th>
                                        <th className='py-3 px-3 whitespace-nowrap'>Quality</th>
                                        <th className='py-3 px-3 whitespace-nowrap'>From</th>
                                        <th className='py-3 px-3 whitespace-nowrap'>To</th>
                                        <th className='py-3 px-3 whitespace-nowrap'>Bill</th>
                                        <th className='py-3 px-3 whitespace-nowrap'>Payment</th>
                                        <th className='py-3 px-3 whitespace-nowrap'>Pay Type</th>
                                        <th className='py-3 px-3 whitespace-nowrap'>Vehicle</th>
                                        <th className='py-3 px-3 whitespace-nowrap'>Driver</th>
                                        <th className='py-3 px-3 whitespace-nowrap'>Party Sig</th>
                                        <th className='py-3 px-3 whitespace-nowrap'>Labour</th>
                                        <th className='py-3 px-3 whitespace-nowrap'>Slip No</th>
                                        <th className='py-3 px-3 whitespace-nowrap'>Book No</th>

                                    </tr>
                                </thead>
                                <tbody className='divide-y'>
                                    {transactions.map(t => {
                                        calculateSummary(summary, t)
                                        return <TableRow {...t} data={t} key={t.docid} selectedRecord={selectedRecord} selectHandler={selectHandler} />

                                    })}
                                    {true && <SummaryRow key={"summary"} {...summary} unit={"trip"} />}
                                </tbody>
                            </table>
                           
                            <div className="w-full flex justify-center">
                                <button  onClick={generateBill} className='mx-auto my-6 p-2 bg-sky-500 hover:bg-sky-600 text-white font-bold rounded'>Generate Bill</button>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

function TableRow({ selectedRecord, docid, selectHandler, date, party_name, supplier_name, material, quantity, unit, quality, from, to, bill, paid, payment_type, vehicle, driver, party_sig, labour, slip_no, book_no, remarks, data }) {

    //console.log({docid,selectedDocId})
    return (
        <tr onClick={() => selectHandler(data)} className={`hover:bg-gray-100 cursor-pointer ${docid === selectedRecord.docid ? "bg-blue-100" : ""}`}>
            <td className='py-3 px-3  whitespace-nowrap'>{getDateString(date)}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{getTimeString(date)}</td>
            <td className='py-3 px-3 whitespace-normal'>{party_name}</td>
            <td className='py-3 px-1 whitespace-nowrap'>{supplier_name}</td>
            <td className='py-3 px-1 whitespace-nowrap'>{material}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{quantity > 0 ? quantity : "" + ' ' + unit}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{quality}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{from}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{to}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{bill>0?bill:"NIL"}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{paid}</td>
            <td className='py-3 px-1 whitespace-nowrap'>{payment_type}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{vehicle}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{driver}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{party_sig}</td>
            <td className='py-3 px-3 whitespace-nowrap parent'>
                {labour === "" ? "" : labour.split(',').length}
                <div className='showOnHover shadow-md'>{labour}</div>
            </td>
            <td className='py-3 px-3 whitespace-nowrap'>{slip_no}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{book_no}</td>
        </tr>
    )
}
function SummaryRow({ totalQuantity = 0, unit = "unit", totalBill = 0, totalPaid = 0 }) {
    return (
        <tr className={`bg-gray-200`}>
            <td className='py-3 px-3 whitespace-nowrap'>{" "}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{" "}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{" "}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{" "}</td>
            <td className='py-3 px-3 whitespace-nowrap'>Quantity:</td>
            <td className='py-3 px-3 whitespace-nowrap font-medium'>{totalQuantity + ' ' + unit}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{" "}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{" "}</td>
            <td className='py-3 px-3 whitespace-nowrap font-bold text-right'>Bill:</td>
            <td className='py-3 px-3 whitespace-nowrap font-medium'>{totalBill}</td>
            <td className={`py-3 px-3 whitespace-nowrap font-medium ${totalBill > totalPaid ? 'text-red-500' : 'text-green-600'}`}>{totalPaid}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{" "}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{" "}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{" "}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{" "}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{" "}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{" "}</td>
            <td className='py-3 px-3 whitespace-nowrap'>{" "}</td>

        </tr>
    )
}
function calculateSummary(summary, t) {
    summary.totalQuantity = summary.totalQuantity + parseInt(t.quantity)
    summary.totalBill = summary.totalBill + parseInt(t.bill)
    summary.totalPaid = summary.totalPaid + parseInt(t.paid)
}
